import { decryptData } from "./crypt";

export const dataUser = {
  getToken() {
    const raw = localStorage.getItem("token");
    return raw ? decryptData(raw) : null;
  },

  getUsername() {
    const raw = localStorage.getItem("username");
    return raw ? decryptData(raw) : "";
  },

  getNickname() {
    const raw = localStorage.getItem("nickname");
    return raw ? decryptData(raw) : "";
  },

  getRole() {
    const raw = localStorage.getItem("roleAccess");
    return raw ? decryptData(raw) : "";
  },

  isLoggedIn() {
    return localStorage.getItem("isLoggedIn") === "true";
  },

  clear() {
    localStorage.clear();
  }
};